import React from "react";
import { useLocation } from "react-router-dom";
import { BAND } from "../data/content";

export default function Footer({ theme }) {
  const isSynth = theme === "synthwave";
  const { pathname } = useLocation();
  // Hide the footer on the home page so nothing appears below the brick logo.
  if (pathname === "/") return null;
  return (
    <footer
      data-testid="site-footer"
      className={`py-12 ${
        isSynth
          ? "bg-[#050510] border-t border-fuchsia-500/30"
          : "bg-[#12100e] border-t border-[#c44900]/30"
      }`}
    >
      <div className="container-x flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <div
            className={`font-display text-2xl uppercase ${
              isSynth ? "neon-gradient-text" : "text-[#f4ebd8]"
            }`}
          >
            OUT OF TOUCH
          </div>
          <div
            className={`text-xs uppercase tracking-[0.3em] mt-1 ${
              isSynth ? "text-cyan-300" : "font-stamp text-[#a89f91]"
            }`}
          >
            {BAND.tagline}
          </div>
        </div>

        <div
          className={`text-xs uppercase tracking-[0.25em] ${
            isSynth ? "text-gray-400" : "text-[#a89f91] font-stamp"
          }`}
        >
          © {new Date().getFullYear()} Out Of Touch · {BAND.city} · All hooks
          reserved
        </div>

        {/*
          Instagram link — hidden until an account is set up.
          When ready: uncomment this block and paste the profile URL into href.
        */}
        {false && (
          <div className="flex gap-6">
            <a
              href="#"
              data-testid="social-instagram"
              className={`text-xs uppercase tracking-[0.3em] transition-colors ${
                isSynth
                  ? "text-fuchsia-400 hover:text-cyan-300"
                  : "text-[#d4af37] hover:text-[#c44900]"
              }`}
            >
              Instagram
            </a>
          </div>
        )}
      </div>
    </footer>
  );
}
